<div class="arrowBtn d-none d-md-inline">
    <a (click)="goBack()" class="btn btn-outline-dark">
        <i class="bi bi-arrow-left arrowIcon"></i>
    </a>
</div>

<div class="container-fluid p-1 p-md-2 p-lg-3 p-xl-4" style="background-color: white; min-height: 90vh;">
    <div class="row justify-content-center">
        <div [formGroup]="newTicketForm" class="col-12 text-center mt-2" style="max-width: 1200px;">
            <span class="panelTitle">
                {{"TICKET.NEW.NEWTICKETSMALL" | translate}}
            </span>

            <div class="row justify-content-center mt-2 p-1 p-md-2 p-lg-3">
                <!-- SYSTEM POPUP -->
                <div
                    class="col-12 col-md-6 mt-2 order-1 order-md-2 d-flex align-items-center justify-content-md-center">
                    <span class="form-label">
                        {{"TICKET.NEW.SYSTEMINFO" | translate}}
                    </span>
                    <button class="btn btn-sm btn-outline-dark ms-2" (click)="systemInfoPopup()">
                        <i class="bi bi-card-text"></i>
                    </button>
                </div>

                <!-- EMAIL -->
                <div class="col-12 col-md-6 mt-2 text-start order-2 order-md-1">
                    <label class="form-label" for="email">
                        {{"TICKET.NEW.EMAIL" | translate}}
                    </label>
                    <input class="form-control" type="text" id="email" formControlName="email" style="max-width: 400px;"
                        [class.is-invalid]="newTicketForm.get('email')?.invalid && (newTicketForm.get('email')?.dirty || submitted)">
                </div>

                <!-- REQUEST -->
                <!-- <div class="col-12 col-md-6 text-start">
                    <label class="form-label" for="request">
                        {{"TICKET.NEW.REQUEST" | translate}}
                    </label>
                    <select class="form-select" id="request" formControlName="request"
                        [class.is-invalid]="newTicketForm.get('request')?.invalid && submitted">
                        <option [ngValue]="null">
                            --
                        </option>
                        <option *ngFor="let request of requestList" [ngValue]="request.id">
                            {{request.title}}
                        </option>
                    </select>
                </div> -->
            </div>

            <div class="row justify-content-center ps-1 pe-1 ps-md-2 pe-md-2 ps-lg-3 pe-lg-3 pt-0">
                <ng-container>
                    <div class="col-12 mt-1">
                        <span style="font-weight: bold; font-size: large; border-bottom: 1px solid lightgray;">
                            {{"TICKET.NEW.ANOMALYFOUNDED" | translate}}
                        </span>
                    </div>

                    <!-- INVERTER LIST -->
                    <div *ngIf="inverterList.length > 0" class="col-12 mb-2 ps-md-3 ps-lg-5 pe-md-3 pe-lg-5 text-start"
                        formArrayName="inverterList">
                        <span class="listTitle">
                            {{"TICKET.NEW.INVERTERLIST" | translate}}
                        </span>
                        <div class="row align-items-group mt-2" style="border-bottom: 1px solid lightgray;">
                            <div class="col-12 col-sm-6 col-md-4 col-xl-3 text-start"
                                *ngFor="let inverter of inverterList.controls; let i = index" [formGroupName]="i">
                                <div class="form-check">
                                    <label class="form-check-label ms-2" for="selected_inverter-{{i}}">
                                        {{inverter.get('sn')?.value}}
                                    </label>
                                    <input class="form-check-input" type="checkbox" id="selected_inverter-{{i}}"
                                        formControlName="selected">
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- BATTERY LIST -->
                    <div *ngIf="batteryList.length > 0" class="col-12 mb-2 ps-md-3 ps-lg-5 pe-md-3 pe-lg-5 text-start"
                        formArrayName="batteryList">
                        <span class="listTitle">
                            {{"TICKET.NEW.BATTERYLIST" | translate}}
                        </span>
                        <div class="row align-items-group mt-2" style="border-bottom: 1px solid lightgray;">

                            <div class="col-12 col-sm-6 col-md-4 col-xl-3 text-start"
                                *ngFor="let battery of batteryList.controls; let i = index" [formGroupName]="i">
                                <div class="form-check">
                                    <label class="form-check-label ms-2" for="selected_battery-{{i}}">
                                        {{battery.get('sn')?.value}}
                                    </label>
                                    <input class="form-check-input" type="checkbox" id="selected_battery-{{i}}"
                                        formControlName="selected">
                                </div>
                            </div>
                        </div>
                    </div>
                </ng-container>

                <!-- DESCRIPTION -->
                <div class="col-12 mt-2 text-start quillContainer"
                    [ngClass]="{ 'is-invalid': newTicketForm.get('description')?.invalid && submitted }">
                    <quill-editor formControlName="description" id="description" rows="3">
                        <div above-quill-editor-toolbar>
                            <span class="form-label" for="description">
                                {{"TICKET.NEW.PROBLEMDESCRIPTION" | translate}}
                            </span>
                        </div>
                        <div quill-editor-toolbar>
                            <span class="ql-formats">
                                <button class="ql-bold" title="Bold"></button>
                                <button class="ql-italic" title="Italic"></button>
                                <button class="ql-underline" title="Underline"></button>
                                <button class="ql-strike" title="Strikethrough"></button>
                            </span>

                            <span class="ql-formats">
                                <select class="ql-font" title="Font Style">
                                    <option selected></option>
                                    <option value="serif"></option>
                                    <option value="monospace"></option>
                                </select>
                                <select class="ql-size" title="Font Size">
                                    <option value="small"></option>
                                    <option selected></option>
                                    <option value="large"></option>
                                    <option value="huge"></option>
                                </select>
                            </span>

                            <span class="ql-formats">
                                <button class="ql-list" value="ordered" title="Ordered List"></button>
                                <button class="ql-list" value="bullet" title="Bullet List"></button>
                                <button class="ql-indent" value="-1" title="Decrease Indent"></button>
                                <button class="ql-indent" value="+1" title="Increase Indent"></button>
                            </span>

                            <span class="ql-formats">
                                <select class="ql-align" title="Align">
                                    <option selected></option>
                                    <option value="center"></option>
                                    <option value="right"></option>
                                    <option value="justify"></option>
                                </select>
                            </span>

                            <span class="ql-formats">
                                <select class="ql-color" title="Text Color"></select>
                            </span>
                        </div>
                    </quill-editor>
                </div>

                <div class="col-12 mt-1">
                    <span style="font-size: small; color: gray; font-style: italic;">
                        {{"TICKET.NEW.MAXTHREE" | translate}}
                    </span>
                </div>

                <div class="col-12 mt-1">
                    <div class="row justify-content-center">
                        <div *ngFor="let img of imagesList; let i = index" class="col-auto" style="position: relative;">
                            <img style="height: 50px; width: 40px; border: 1px solid lightgray; object-fit: cover;"
                                [src]="img.src" [title]="img.src">
                            <button class="btn btn-danger p-0" style="position: absolute; right: 8px; top: -4px"
                                (click)="deleteFile(i)">
                                <i class="bi bi-x"></i>
                            </button>
                        </div>

                        <div class="col-auto">
                            <label *ngIf="fileList.length < maxImages" for="fileUpload2"
                                class="btn btn-outline-dark mt-1">
                                <i class="bi bi-paperclip"></i>
                                <input type="file" id="fileUpload2" style="display: none;"
                                    (change)="onFileSelected($event)" multiple>
                            </label>
                        </div>
                    </div>
                </div>

                <div *ngIf="newTicketForm.invalid && submitted" class="col-12 mt-2">
                    <span style="font-size: small; color: red;">
                        {{"TICKET.NEW.MANDATORYFIELDS" | translate}}
                    </span>
                </div>
            </div>

            <div class="row justify-content-end mt-3 pt-1 ps-1 pe-1 pt-md-2 ps-md-2 pe-md-2 pt-lg-3 ps-lg-3 pe-lg-3"
                style="border-top: 1px solid lightgray;">
                <div class="col-auto">
                    <button class="btn btn-outline-success" (click)="createTicket()">
                        {{"TICKET.NEW.CREATE" | translate}}
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>